// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"q8-z"};